import React from 'react';
import { View } from 'react-native';

const WalletButton = () => {
  return <View></View>;
};

// TODO: JT-139790 Clean this up and move into a helper file or just call isSamsung directly from @varo/expo-wallet-provisioning
export const isSamsungDevice = () => {
  return false;
};

export default WalletButton;
